import type { TFunction } from "i18next"

import type { Pattern } from "./types"

// Deterministic sentences filled from calculated values; they state the
// measured comparison and its counts, never a cause (spec §4).
export const patternText = (t: TFunction, pattern: Pattern): string =>
  t(`teamPerformance.patterns.${pattern.kind}`, pattern.params)

export const patternAction = (t: TFunction, pattern: Pattern): string => {
  const p = pattern.params
  if (pattern.kind === "type_trails_benchmark")
    return t("teamPerformance.member.viewProjectsOf", { name: p.type })
  if (pattern.kind === "milestone_late_pattern")
    return t("teamPerformance.member.viewProjectsOf", { name: p.milestone })
  return t("teamPerformance.member.viewProjectsOf", { name: p.period })
}
